import { api } from './client';

export interface Gstr1ValidationResult {
  period: string;
  checks: { name: string; passed: boolean; detail: string }[];
  allPassed: boolean;
  invoiceCount: number;
}

export interface GstrFilingResult {
  status: 'filed' | 'rejected';
  ackNumber?: string;
  filedAt?: string;
  period?: string;
  errorMessage?: string;
  note?: string;
}

export interface GstrFilingLog {
  id: string;
  returnType: string;
  period: string;
  filedAt?: string;
  ackNumber?: string;
  status: 'pending' | 'filed' | 'rejected';
  errorMessage?: string;
  createdAt: string;
}

export const gstrFilingApi = {
  validateGstr1: (from: string, to: string) =>
    api.get<Gstr1ValidationResult>(`/gstr-filing/gstr1/validate?from=${from}&to=${to}`),
  fileGstr1: (from: string, to: string, otp: string) =>
    api.post<GstrFilingResult>('/gstr-filing/gstr1/file', { from, to, otp }),
  getHistory: () => api.get<GstrFilingLog[]>('/gstr-filing/history'),
};
